import React, { FC, SVGProps } from "react";

const Check: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="5 3 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d)">
        <path
          d="M19 31C26.681 31 33 24.681 33 17C33 9.31896 26.667 3 18.986 3C11.3049 3 5 9.31896 5 17C5 24.681 11.319 31 19 31Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M17.2166 24.1189C16.6268 24.1189 16.1634 23.8521 15.7703 23.3887L11.9508 18.825C11.6559 18.488 11.5295 18.1369 11.5295 17.7578C11.5295 16.9434 12.1895 16.2974 12.9899 16.2974C13.4533 16.2974 13.8324 16.494 14.1835 16.9012L17.1745 20.5662L22.9177 11.4388C23.2688 10.8912 23.7041 10.6104 24.2096 10.6104C24.9959 10.6104 25.7121 11.172 25.7121 11.9865C25.7121 12.3235 25.5717 12.6886 25.361 13.0256L18.6208 23.3325C18.2838 23.838 17.7783 24.1189 17.2166 24.1189Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="38"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Check;
